import desk3500 from '../assets/equipment/DESK3500.jpg';
import move5000 from '../assets/equipment/MOVE5000.jpg';
import desk1500 from '../assets/equipment/DESK1500-PP.png';
import s1f4pro from '../assets/equipment/S1F4PRO.png';
// Product photos by catalog SKU — the same photos as the paper equipment order form. Bundled with the app rather than
// stored per brand: the three brands share one catalog, and the photos change with the hardware, not the brand.
const BY_SKU = { DESK3500: desk3500, 'MOVE5000-WIFI': move5000, 'MOVE5000-4G': move5000, 'DESK1500-PP': desk1500, S1F4PRO: s1f4pro };
export const equipmentImage = sku => BY_SKU[sku] || null;
